<template>
	<div class="full-width pa-4">
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-form ref="form">
			<v-layout>
				<v-flex xs12 md3>
					<v-radio-group
						v-model="selectedMediaType"
						:mandatory="true"
						row
					>
						<v-radio
							color="primary"
							label="Image"
							:value="mediaTypes.image"
						></v-radio>
						<v-radio
							color="primary"
							label="Video"
							:value="mediaTypes.video"
						>
							></v-radio
						>
					</v-radio-group>
				</v-flex>
			</v-layout>
			<v-layout mt2 mb2>
				<v-flex>
					<v-flex v-if="selectedMediaType === mediaTypes.image">
						<input
							v-show="false"
							ref="inputUpload"
							type="file"
							@change="filePicked"
							accept="image/*"
						/>
						<v-btn
							color="primary"
							class="mb-3"
							@click="$refs.inputUpload.click()"
							>Upload File</v-btn
						>
					</v-flex>
					<v-text-field
						v-else
						label="Enter YouTube URL"
						v-model="mediaUrl"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout v-if="imageFileName">
				<v-flex>
					<img class="uploadedImage" :src="imageFileUrl" />
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12 sm12 md4 lg3>
					<v-autocomplete
						label="Select State*"
						v-model="selectedState"
						:rules="[requiredRule]"
						:items="states"
						:autcomplete="false"
						clearable
					></v-autocomplete>
					<v-autocomplete
						v-model="selectedCity"
						label="Select City*"
						:rules="[requiredRule]"
						:items="cities"
						:autcomplete="false"
						:loading="fetchCitiesLoading"
						:disabled="isSelectedStateEmpty"
						clearable
					></v-autocomplete>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12 sm12 md4 lg3>
					<v-text-field
						label="Enter Story Title"
						v-model="storyTitle"
						clearable
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs11 sm6 lg3>
					<v-text-field
						label="Enter Story Description"
						v-model="storyDescription"
						clearable
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs11 sm6 lg3>
					<v-text-field
						label="Enter User Phone"
						v-model="userPhoneNo"
						:rules="[validPhoneRule]"
						clearable
						prefix="91"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex class="mt-4" xs11 sm6 lg3>
					<v-btn
						:loading="uploadUserStoryLoading"
						color="primary"
						@click="uploadUserStory"
						>SUBMIT</v-btn
					>
				</v-flex>
			</v-layout>
		</v-form>
	</div>
</template>

<script>
import { mapState } from "vuex";

import {
	FETCH_REGIONS,
	UPLOAD_USER_STORY,
	SHOW_ALERT,
	UPLOAD_MEDIA_TO_SERVER
} from "@/store/action-types";

import { REGION_TYPE, themeInputColor } from "@/utils";

import { _validPhoneNoRule } from "@/utils";

export default {
	name: "UploadUserStoriesTool",
	props: ["title", "themeInputColor"],
	data() {
		return {
			selectedMediaType: "IMAGE",
			mediaUrl: "",
			selectedState: "",
			selectedCity: "",
			storyTitle: "",
			storyDescription: "",
			userPhoneNo: "",
			mediaTypes: {
				image: "IMAGE",
				video: "VIDEO"
			},
			uploadUserStoryLoading: false,
			fetchCitiesLoading: false,
			imageFileName: "",
			imageFileUrl: "",
			imageFileObject: "",
			requiredRule: (v) => !!v || "This is required",
			validPhoneRule: _validPhoneNoRule
		};
	},
	computed: {
		...mapState({
			states: (state) => state.common.states,
			cities: (state) => state.common.cities,
			uploadedMediaUrl: (state) => state.uploadMedia.userStory
		}),
		isSelectedStateEmpty: function () {
			return !this.selectedState;
		}
	},
	methods: {
		filePicked(event) {
			const files = event.target.files;
			if (files[0] !== undefined) {
				this.imageFileName = files[0].name;
				if (this.imageFileName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.imageFileUrl = fr.result;
					this.imageFileObject = files[0];
				});
			} else {
				this.imageFileName = null;
				this.imageFileObject = null;
				this.imageFileUrl = null;
			}
		},
		fetchCities(setDefault) {
			this.selectedCity = null;
			this.fetchCitiesLoading = true;
			this.$store
				.dispatch(FETCH_REGIONS.dispatch, {
					regionType: REGION_TYPE.CITY,
					state: this.selectedState,
					dataKey: "cities"
				})
				.catch(() => {})
				.then(() => {
					this.fetchCitiesLoading = false;
					if (setDefault) {
						this.selectedCity = this.defaultCity;
					}
				});
		},
		isFormCorrect() {
			if (!this.selectedMediaType) return false;
			if (!this.selectedCity) return false;
			if (!this.selectedState) return false;
			if (this.selectedMediaType === this.mediaTypes.image) {
				if (!this.imageFileObject) return false;
			}
			if (this.selectedMediaType === this.mediaTypes.video) {
				if (!this.mediaUrl) return false;
			}
			return true;
		},
		dispatchUploadMediaToServer() {
			return this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: "userStory",
					file: this.imageFileObject,
					type: "imageUpload"
				})
				.catch(() => {
					throw new Error();
				})
				.then(() => {
					this.mediaUrl = this.uploadedMediaUrl;
					return;
				});
		},
		dispatchUploadUserStory() {
			return this.$store
				.dispatch(UPLOAD_USER_STORY.dispatch, {
					phoneNo: this.userPhoneNo ? this.userPhoneNo : null,
					mediaUrl: this.mediaUrl,
					mediaType: this.selectedMediaType,
					city: this.selectedCity,
					state: this.selectedState,
					title: this.storyTitle ? this.storyTitle : null,
					description: this.storyDescription
						? this.storyDescription
						: null
				})
				.then(() => {
					this.resetData();
					return;
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		uploadUserStory() {
			if (!this.isFormCorrect()) {
				this.showAlert("INCORRECT DETAILS");
				return;
			}
			if (!this.uploadUserStoryLoading) {
				this.uploadUserStoryLoading = true;
				if (this.selectedMediaType === this.mediaTypes.image) {
					this.dispatchUploadMediaToServer()
						.then(() => {
							this.dispatchUploadUserStory();
						})
						.catch(() => {})
						.finally(() => {
							this.uploadUserStoryLoading = false;
						});
				} else if (this.selectedMediaType === this.mediaTypes.video) {
					this.dispatchUploadUserStory()
						.catch(() => {})
						.finally(() => {
							this.uploadUserStoryLoading = false;
						});
				}
			}
		},
		showAlert(payload) {
			this.$store.dispatch(SHOW_ALERT.dispatch, { text: payload });
		},
		resetData() {
			this.imageFileName = null;
			this.imageFileUrl = null;
			this.mediaUrl = null;
			this.imageFileObject = null;
			this.storyTitle = null;
			this.storyDescription = null;
			this.userPhoneNo = null;
			this.selectedState = null;
			this.selectedCity = null;
			this.$refs.form.resetValidation();
		}
	},
	watch: {
		selectedState(newVal) {
			if (newVal) {
				const setDefault = newVal === this.defaultState;
				this.fetchCities(setDefault);
			} else {
				this.selectedCity = null;
			}
		},
		selectedMediaType(newVal) {
			if (newVal === this.mediaTypes.video) {
				this.imageFileName = null;
				this.imageFileObject = null;
				this.imageFileUrl = null;
			}
			if (newVal === this.mediaTypes.image) {
				this.mediaUrl = null;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.uploadedImage {
	max-width: 600px;
}
</style>